import { ZipApi } from '../../lib/ZipApi';
import { directoryStore } from '../DirectoryStore';
import { ObjectDefinition, OptimizelyProduct } from '../../types/DataSyncItem';
import { DataSyncObjectsStore } from './DataSyncObjectsStore';
import { FieldDefinition } from '../../types/FieldDefinition';
import { convertSchemaV2ToObjectDefinition } from '../../lib/convertV2Schema';
import { showToasts } from '../../lib/toaster';

export default class DataSyncCmpObjectsStore extends DataSyncObjectsStore {

  public async getSourceObjectFields(objectName: string): Promise<FieldDefinition[]> {
    const object = this._sourceObjectDefinitions?.find((obj) => obj.object_name === objectName);
    if (!object) {
      return [];
    }
    if (object.fields.length > 0) {
      return object.fields;
    }

    if (!directoryStore.trackerId || !this.instanceId || !objectName) {
      return [];
    }

    this.loading = true;
    try {
      const schema = await ZipApi.getSourceSchema(
        directoryStore.trackerId,
        OptimizelyProduct.CMP,
        this.instanceId,
        objectName
      );
      const objectDef = convertSchemaV2ToObjectDefinition(schema);
      if (objectDef?.fields) {
        object.fields = objectDef.fields;
        return objectDef.fields;
      }
    } catch (error: any) {
      await this.handleSourceFetchError(error);
    } finally {
      this.loading = false;
    }

    return [];
  }

  protected async fetchSourceObjectDefinitions(): Promise<ObjectDefinition[]> {
    if (!directoryStore.trackerId || !this.instanceId) {
      return [];
    }
    const response = await ZipApi.listSourceSchemas(
      directoryStore.trackerId,
      OptimizelyProduct.CMP,
      this.instanceId
    );
    if (!response?.schemas) {
      return [];
    }
    return response.schemas.map((item) => ({
      object_name: item.id,
      object_display_name: item.display_name || item.id,
      object_icon_url: '',
      fields: [],
      disabled: item.disabled,
      warning: item.warning,
    }));
  }

  protected async fetchDestinationObjectDefinitions(): Promise<ObjectDefinition[]> {
    throw new Error('CMP destination is not supported');
  }

  protected async handleSourceFetchError(_error: any): Promise<void> {
    showToasts([{intent: 'danger', message: 'Unable to fetch CMP schema, please try again later.'}]);
  }
}
